import { render, staticRenderFns } from "./Editbar.vue?vue&type=template&id=736fd9ec&scoped=true"
var script = {}
import style0 from "./Editbar.vue?vue&type=style&index=0&id=736fd9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736fd9ec",
  null
  
)

export default component.exports